import axios from "axios";
import { toast } from "react-toastify";

export const FETCH_TICKETS_REQUEST = "FETCH_TICKETS_REQUEST";
export const FETCH_TICKETS_SUCCESS = "FETCH_TICKETS_SUCCESS";
export const FETCH_TICKETS_FAILURE = "FETCH_TICKETS_FAILURE";
export const FETCH_SPOTS_SUCCESS = "FETCH_SPOTS_SUCCESS";
export const UPDATE_TICKET_STATUS = "UPDATE_TICKET_STATUS";

export const fetchTickets = (params, filterType = null) => async (dispatch, getState) => {
  dispatch({ type: FETCH_TICKETS_REQUEST });
  
  try {
    const { AuthReducer: { auth } } = getState();
    
    // Clean params - remove undefined values
    const cleanParams = Object.fromEntries(
      Object.entries(params).filter(([_, value]) => value !== undefined && value !== null && value !== '')
    );
    
    const response = await axios.get("/api/admin/v1/ticket-booking-list", {
      headers: { Authorization: `Bearer ${auth?.token}` },
      params: cleanParams,
    });

    let tickets = response.data.bookings || [];
    if (filterType === 'online') {
      tickets = tickets.filter(b => b.ticket_booking_type === 'online');
    } else if (filterType === 'counter') {
      tickets = tickets.filter(b => b.ticket_booking_type === 'counter');
    }

    dispatch({
      type: FETCH_TICKETS_SUCCESS,
      payload: {
        tickets,
        count: response.data.bookingCount || 0,
        filterType
      }
    });
  } catch (error) {
    dispatch({
      type: FETCH_TICKETS_FAILURE,
      payload: error.response?.data?.message || "Failed to fetch tickets"
    });
    toast.error("Failed to fetch tickets");
  }
};

export const fetchTransactions = (params) => async (dispatch, getState) => {
  dispatch({ type: FETCH_TICKETS_REQUEST });
  
  try {
    const { AuthReducer: { auth } } = getState();
    
    // Clean params - remove undefined values
    const cleanParams = Object.fromEntries(
      Object.entries(params).filter(([_, value]) => value !== undefined && value !== null && value !== '')
    );
    
    const response = await axios.get("/api/admin/v1/transactions-history", {
      headers: { Authorization: `Bearer ${auth?.token}` },
      params: cleanParams,
    });

    dispatch({
      type: FETCH_TICKETS_SUCCESS,
      payload: {
        tickets: response.data.transactions || [],
        count: response.data.totalCount || 0,
        filterType: 'transactions'
      }
    });
  } catch (error) {
    dispatch({
      type: FETCH_TICKETS_FAILURE,
      payload: error.response?.data?.message || "Failed to fetch transactions"
    });
    toast.error("Failed to fetch transaction history");
  }
};

export const fetchSpots = () => async (dispatch, getState) => {
  try {
    const { AuthReducer: { auth } } = getState();
    const response = await axios.get("/api/admin/v1/ticket-booking-list", {
      headers: { Authorization: `Bearer ${auth?.token}` },
      params: { limit: 1000 },
    });
    
    const uniqueSpots = [...new Set(response.data.bookings?.map(b => b.place?.place_name).filter(Boolean))];
    
    dispatch({
      type: FETCH_SPOTS_SUCCESS,
      payload: uniqueSpots
    });
  } catch (error) {
    console.error("Failed to fetch spots");
  }
};

export const updateTicketStatus = (ticketId, status) => async (dispatch, getState) => {
  try {
    const { AuthReducer: { auth } } = getState();
    await axios.put(`/api/admin/v1/ticket-status/${ticketId}`, 
      { status }, 
      { headers: { Authorization: `Bearer ${auth?.token}` } }
    );
    
    dispatch({
      type: UPDATE_TICKET_STATUS,
      payload: { ticketId, status }
    });
    
    toast.success(`Ticket ${status === 'used' ? 'marked as used' : 'cancelled'}`);
  } catch (error) {
    toast.error("Failed to update ticket status");
  }
};